import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import API_URL from "../config/config";
import "../css/checkout.css";

function Checkout() {
  const navigate = useNavigate();

  const user = JSON.parse(localStorage.getItem("user"));

  const [paymentMethod, setPaymentMethod] = useState("stripe");
  const [cartItems, setCartItems] = useState([]);

  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    address: "",
    city: "",
    state: "",
    zipCode: ""
  });

  // Load Cart
  useEffect(() => {
    if (!user) return;

    axios
      .get(`${API_URL}/cart/${user.id}`)
      .then((res) => {
        setCartItems(res.data);
      })
      .catch((err) => console.log(err));
  }, [user]);

  const subtotal = cartItems.reduce(
    (sum, item) => sum + item.price * item.quantity,
    0
  );

  const shipping = subtotal > 100 ? 0 : 10;
const tax = subtotal * 0.0825;
  const grandTotal = subtotal + shipping + tax;

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!user) {
      alert("Please login first.");
      navigate("/login");
      return;
    }

    if (cartItems.length === 0) {
      alert("Cart is empty.");
      return;
    }

    try {
      const data = {
        user_id: user.id,
        full_name: formData.fullName,
        email: formData.email,
        phone: formData.phone,
        address: formData.address,
        city: formData.city,
        state: formData.state,
        zip_code: formData.zipCode
      };

      if (paymentMethod === "stripe") {
        const res = await axios.post(
          `${API_URL}/create-checkout-session`,
          data
        );

        window.location.href = res.data.url;
      } else {
        const res = await axios.post(
          `${API_URL}/cash-order`,
          data
        );

        navigate(`/order-success?id=${res.data.orderId}`);
      }
    } catch (err) {
      console.log(err);
      alert("Order failed");
    }
  };

  return (
    <div className="checkout-page">

      <div className="checkout-container">

        <h1>Checkout</h1>

        <form
          className="checkout-form"
          onSubmit={handleSubmit}
        >

          <input
            type="text"
            name="fullName"
            placeholder="Full Name"
            value={formData.fullName}
            onChange={handleChange}
            required
          />

          <input
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            required
          />

          <input
            type="text"
            name="phone"
            placeholder="Phone"
            value={formData.phone}
            onChange={handleChange}
            required
          />

          <textarea
            name="address"
            placeholder="Address"
            value={formData.address}
            onChange={handleChange}
            required
          />

          <input
            type="text"
            name="city"
            placeholder="City"
            value={formData.city}
            onChange={handleChange}
            required
          />

          <input
            type="text"
            name="state"
            placeholder="State"
            value={formData.state}
            onChange={handleChange}
            required
          />

          <input
            type="text"
            name="zipCode"
            placeholder="ZIP Code"
            value={formData.zipCode}
            onChange={handleChange}
            required
          />

          <div className="payment-method">

            <h3>Payment Method</h3>

            <label>
              <input
                type="radio"
                value="stripe"
                checked={paymentMethod === "stripe"}
                onChange={(e) =>
                  setPaymentMethod(e.target.value)
                }
              />
              Pay Online (Stripe)
            </label>

            <br />

            <label>
              <input
                type="radio"
                value="cod"
                checked={paymentMethod === "cod"}
                onChange={(e) =>
                  setPaymentMethod(e.target.value)
                }
              />
              Cash On Delivery
            </label>

          </div>

          <button
            type="submit"
            className="place-order-btn"
          >
            {paymentMethod === "stripe"
              ? "Pay Now"
              : "Place COD Order"}
          </button>

        </form>

      </div>

      <div className="order-summary">

        <h2>Order Summary</h2>

        {cartItems.map((item) => (
          <div
            key={item.id}
            className="summary-item"
          >
            <span>
              {item.product_name} × {item.quantity}
            </span>

            <span>
              ${(item.price * item.quantity).toFixed(2)}
            </span>
          </div>
        ))}

        <hr />

        <div className="summary-item">
          <span>Subtotal</span>
          <span>${subtotal.toFixed(2)}</span>
        </div>

        <div className="summary-item">
          <span>Shipping</span>
          <span>
            {shipping === 0
              ? "FREE"
              : `$${shipping.toFixed(2)}`}
          </span>
        </div>

        <div className="summary-item">
        <span>Tax (8.25%)</span>
          <span>${tax.toFixed(2)}</span>
        </div>

        <hr />

        <div className="summary-total">
          <span>Grand Total</span>
          <span>${grandTotal.toFixed(2)}</span>
        </div>

      </div>

    </div>
  );
}

export default Checkout;